import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, ArrowRight } from "lucide-react";
import { api, money, fmtDate } from "@/lib/api";
import PageHeader, { Empty } from "@/components/PageHeader";
import { t } from "@/lib/i18n";

export default function Connections() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/connections").then((r) => setItems(r.data)); }, []);

  return (
    <div>
      <PageHeader kicker={t("Mutually confirmed")} title={t("Connections")} />
      {items?.length === 0 && <Empty title={t("No connections yet")} testId="connections-empty">{t("When a shipper and transporter both confirm a deal, it appears here with full contact details.")}</Empty>}
      <div className="grid md:grid-cols-2 gap-4">
        {items?.map((c, i) => (
          <Link key={c.bid.id} to={`/connections/${c.bid.id}`} className="hf-card p-5 hf-rise hover:border-amber-500 transition-colors" style={{ animationDelay: `${i * 50}ms` }} data-testid={`connection-card-${c.bid.id}`}>
            <div className="flex justify-between gap-3">
              <div className="min-w-0">
                <p className="font-mono text-xs text-slate-500">{c.counterparty.public_code} · {t(c.counterparty.role)}</p>
                <p className="font-display font-bold text-lg truncate">{c.counterparty.company_name}</p>
              </div>
              {c.unread > 0 && <span className="h-6 px-2 rounded-full bg-amber-500 text-slate-900 text-xs font-bold flex items-center gap-1"><MessageSquare className="w-3 h-3" />{c.unread}</span>}
            </div>
            <p className="text-sm mt-3 flex items-center gap-2 flex-wrap">{c.load.loading_area} <ArrowRight className="w-3.5 h-3.5 text-amber-600" /> {c.load.offloading_area}</p>
            <p className="font-mono text-xs text-slate-500 mt-2">{t(c.load.commodity)} · {c.load.tonnage}t · {money(c.bid.price_per_mt, c.load.currency || "USD")}{t("/mt · starts")} {fmtDate(c.load.loading_date)}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
